import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
@Component({
	selector: 'app-svg-editor',
	templateUrl: './svg-editor.component.html',
	styleUrls: ['./svg-editor.component.css']
})
export class SvgEditorComponent implements OnInit {

	iframe: SafeResourceUrl;
	constructor(private sanitizer: DomSanitizer) { }

	ngOnInit() {
		const src = '../../../assets/svgedit-master/editor/svg-editor.html';
		this.iframe = this.sanitizer.bypassSecurityTrustResourceUrl(src);
	}

}
